import React from 'react';
import PropTypes from 'prop-types';
import { RenderMenu } from './rendermenu';
import { MENU_NAV, MENUBAR, NAVIGATION } from '../../modules/constants';

/**
 * Top level menu component
 *
 * @function
 * @param       {array}  top               An array of menu items
 * @param       {string} openMenu          useState variable, which will contain the name of the open sub menu if this applies.
 * @param       {function} setOpenMenu     useState function to set the name of the open sub menu on click.
 * @param       {boolean} openMobileMenu   Is true if the menu opener button clicked was the burger menu button for mobile.
 * @param       {function} setOpenMobileMenu useState function to set if the menu is opened using the burger menu button for mobile
 * @constructor
 */
function Menu({
    top,
    openMenu,
    setOpenMenu,
    openMobileMenu,
    setOpenMobileMenu,
    track
}) {
    if (!top.length) {
        return null;
    }

    const renderMenuProps = {
        aria: MENU_NAV,
        openMenu,
        setOpenMenu,
        openMobileMenu,
        setOpenMobileMenu,
        track,
        role: MENUBAR
    };

    return (
        <nav role={NAVIGATION}>
            <RenderMenu {...renderMenuProps}>{top}</RenderMenu>
        </nav>
    );
}

Menu.propTypes = {
    top: PropTypes.array,
    openMenu: PropTypes.string,
    setOpenMenu: PropTypes.func,
    openMobileMenu: PropTypes.bool,
    setOpenMobileMenu: PropTypes.func,
    track: PropTypes.string
};

export { Menu };
